import type { User } from "@/contexts/AuthContext";

/**
 * Mock users for local development with VITE_SKIP_AUTH=true.
 * These must match the users seeded in the backend database.
 *
 * ⚠️  NEVER use these in production — they bypass all authentication.
 */
export const DEV_USERS: (User & { label: string; description: string })[] = [
  {
    id: 1,
    username: "martin.admin",
    email: "martin.admin@bondit.dk",
    role: "ADMIN",
    is_active: true,
    created_at: "2026-01-01T00:00:00Z",
    label: "Martin Bonde",
    description: "Super Admin — full access to everything",
  },
  {
    id: 2,
    username: "evelyn.admin",
    email: "evelyn.admin@bondit.dev",
    role: "ADMIN",
    is_active: true,
    created_at: "2026-01-01T00:00:00Z",
    label: "Evelyn Admin",
    description: "Admin — same access as Martin",
  },
  {
    id: 3,
    username: "marcel.admin",
    email: "marcel.admin@bondit.dev",
    role: "ADMIN",
    is_active: true,
    created_at: "2026-01-01T00:00:00Z",
    label: "Marcel Admin",
    description: "Admin — same access as Martin",
  },
  {
    id: 4,
    username: "jack.admin",
    email: "jack.admin@bondit.dev",
    role: "ADMIN",
    is_active: true,
    created_at: "2026-01-01T00:00:00Z",
    label: "Jack Admin",
    description: "Admin — same access as Martin",
  },
  {
    id: 5,
    username: "jonas.larsen",
    email: "demo.jonas.larsen@bondit.dev",
    role: "CONSULTANT",
    is_active: true,
    created_at: "2026-01-01T00:00:00Z",
    consultant_profile: {
      id: 5,
      full_name: "Jonas Larsen",
      email: "demo.jonas.larsen@bondit.dev",
      linkedin_url: "https://linkedin.com/in/jonas-larsen",
      phone: "+45 29 12 34 56",
    },
    label: "Jonas Larsen",
    description: "Consultant — cloud-native full-stack architect",
  },
];

/** Check whether skip-auth mode is enabled (local dev only). */
export const isSkipAuthEnabled = (): boolean => import.meta.env.VITE_SKIP_AUTH === "true";
